import { formatDateTime } from "@/v2-common/utils/utils.date"
import Icon from "@/v2-ui/icon"
import cn from "@/v2-ui/utils/utils.cn"
import type { SharingRiskDetailFragment } from "@/v2-backoffice-client/signIn/__types__/signIn.detail.fragment"

export type SharingRiskSessionsProps = {
  className?: string
  sessions:
    | SharingRiskDetailFragment["ConcurrentSessionPairs"]
    | null
    | undefined
}

// Renders concurrent-session overlaps as a labelled, self-explanatory block:
// each overlap is two legs (location · time · IP) stacked under an "Overlap N"
// label, so a reviewer instantly sees two different places signed in at almost
// the same time. Shared verbatim by the risk tooltip and the user-panel card so
// the same signal reads the same way in both surfaces.
function SharingRiskSessions(props: SharingRiskSessionsProps) {
  const { sessions, className } = props
  if (!sessions || sessions.length === 0) return null

  return (
    <ul className={cn("sharing-risk-sessions", className)}>
      {sessions.map((pair, i) => (
        <li key={i} className="sharing-risk-session">
          <span className="sharing-risk-session-label">Overlap {i + 1}</span>
          <SessionLeg
            location={pair.LocationA}
            timestamp={pair.TimestampA}
            ip={pair.IpA}
          />
          <SessionLeg
            location={pair.LocationB}
            timestamp={pair.TimestampB}
            ip={pair.IpB}
          />
        </li>
      ))}
    </ul>
  )
}

type SessionLegProps = {
  location: string | null | undefined
  timestamp: string
  ip: string
}

function SessionLeg(props: SessionLegProps) {
  const { location, timestamp, ip } = props
  return (
    <div className="sharing-risk-session-leg">
      <Icon src="marker" size={11} className="sharing-risk-session-leg-icon" />
      <span className="sharing-risk-session-leg-loc">
        {location || "Unknown location"}
      </span>
      <span className="sharing-risk-session-leg-time">
        {formatDateTime(new Date(timestamp))}
      </span>
      <span className="sharing-risk-session-leg-ip">{ip}</span>
    </div>
  )
}

export default SharingRiskSessions
